<template>
  <div class="listing-hotel-filters">
    <v-sheet height="420px" class="overflow-hidden">
      <site-date-picker
        v-if="isHotelSite"
        :value.sync="dateRange"
        is-range
        is-custom
        :is-hotel-site="isHotelSite"
        @change="updateFilter('dateRange', $event)"
      >
      </site-date-picker>
    </v-sheet>
    <v-divider></v-divider>
    <div class="mt-2 d-flex text-caption secondary--text">
      <v-col cols="4">
        <div>{{ $t("checkin") }}</div>
        <div
          v-if="dateRange.startDate"
          class="font-weight-semibold text-body-2 text--black d-flex"
        >
          <v-icon size="16" color="grey darken-2" class="me-1"
            >mdi-calendar</v-icon
          >
          {{ parseDate(dateRange.startDate, "MMM D") }}
        </div>
        <div v-else class="font-weight-semibold text-body-2 text--black d-flex">
          -
        </div>
      </v-col>
      <v-divider
        vertical
        style="height: 20px; top: 30px"
        class="p-relative"
      ></v-divider>
      <v-col cols="4">
        <div>{{ $t("checkout") }}</div>
        <div
          v-if="dateRange.endDate"
          class="font-weight-semibold text-body-2 text--black d-flex"
        >
          <v-icon size="16" color="grey darken-2" class="me-1"
            >mdi-calendar</v-icon
          >
          {{ parseDate(dateRange.endDate, "MMM D") }}
        </div>
        <div v-else class="font-weight-semibold text-body-2 text--black d-flex">
          -
        </div>
      </v-col>
      <v-divider
        vertical
        style="height: 20px; top: 30px"
        class="p-relative"
      ></v-divider>
      <v-col cols="4">
        <div>{{ $t("nights") }}</div>
        <div
          v-if="nights"
          class="font-weight-semibold text-body-2 text--black d-flex"
        >
          {{ nights }}
        </div>
        <div v-else class="font-weight-semibold text-body-2 text--black d-flex">
          -
        </div>
      </v-col>
    </div>
    <v-divider />
    <div class="my-4 mx-2">
      <div class="d-flex text-body-2 secondary--text">
        <div>{{ $t("adults") }}</div>
        <count-picker
          :value.sync="adults"
          @update:value="updateFilter('adults', $event)"
        />
      </div>
      <div class="d-flex text-body-2 secondary--text">
        <div>{{ $t("children") }}</div>
        <count-picker
          :value.sync="children"
          @update:value="updateFilter('children', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SiteDatePicker from "@/components/common/site-date-picker";
import FormattersMixin from "@/mixins/formatters-mixin";
import CountPicker from "@/components/common/count-picker";
export default {
  name: "listing-hotel-filters",
  mixins: [FormattersMixin],
  components: {
    SiteDatePicker,
    CountPicker,
  },
  props: {
    isHotelSite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      adults: 0,
      children: 0,
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },
  computed: {
    nights() {
      return this.$moment(this.dateRange.endDate).diff(
        this.$moment(this.dateRange.startDate),
        "days"
      );
    },
  },
  mounted() {
    this.populateFilters();
  },
  methods: {
    populateFilters() {
      this.city = this.$route.query.city;
      this.region = this.$route.query.region;
      this.adults = Number(this.$route.query.adults) || 1;
      this.children = Number(this.$route.query.children) || 0;
      this.dateRange = {
        startDate: this.$route.query.check_in,
        endDate: this.$route.query.check_out,
      };
    },
    save() {
      const { startDate, endDate } = this.dateRange;
      const check_in =
        startDate && this.$moment(startDate).format("YYYY-MM-DD");
      const check_out = endDate && this.$moment(endDate).format("YYYY-MM-DD");
      this.$router.push({
        name: "listings",
        query: {
          check_in,
          check_out,
          city: this.city,
          region: this.region,
          adults: this.adults,
          children: this.children,
        },
      });
    },
    updateFilter(type, count) {
      this[type] = count;
      this.save();
    },
  },
};
</script>
